var Variant = /* @__PURE__ */ ((Variant2) => {
  Variant2["primary"] = "primary";
  Variant2["secondary"] = "secondary";
  Variant2["ghost"] = "ghost";
  Variant2["link"] = "link";
  return Variant2;
})(Variant || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["left"] = "left";
  Alignment2["center"] = "center";
  Alignment2["right"] = "right";
  Alignment2["justify"] = "justify";
  return Alignment2;
})(Alignment || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["top"] = "top";
  VerticalAlignment2["center"] = "center";
  VerticalAlignment2["bottom"] = "bottom";
  return VerticalAlignment2;
})(VerticalAlignment || {});
var DSSize = /* @__PURE__ */ ((DSSize2) => {
  DSSize2["small"] = "small";
  DSSize2["medium"] = "medium";
  DSSize2["default"] = "default";
  DSSize2["large"] = "large";
  return DSSize2;
})(DSSize || {});
var DividerTypeEnum = /* @__PURE__ */ ((DividerTypeEnum2) => {
  DividerTypeEnum2["text"] = "text";
  DividerTypeEnum2["icon"] = "icon";
  return DividerTypeEnum2;
})(DividerTypeEnum || {});
var DividerStyleEnum = /* @__PURE__ */ ((DividerStyleEnum2) => {
  DividerStyleEnum2["solid"] = "solid";
  DividerStyleEnum2["double"] = "double";
  DividerStyleEnum2["dotted"] = "dotted";
  DividerStyleEnum2["dashed"] = "dashed";
  return DividerStyleEnum2;
})(DividerStyleEnum || {});

export { Alignment, DSSize, DividerStyleEnum, DividerTypeEnum, Variant, VerticalAlignment };
